import Plausible from 'plausible-tracker';

interface PlausibleTracker {
  trackPlausibleEvent: (
    eventName: string,
    props?: Record<string, string | number>
  ) => void;
}

export const usePlausible = (): PlausibleTracker => {
  const plausible = Plausible({
    domain: 'app.hooklistener.com',
    apiHost: 'https://ps.lemonity.com',
  });

  const trackPlausibleEvent = (
    eventName: string,
    props?: Record<string, string | number>
  ) => {
    plausible.trackEvent(eventName, { props });
  };

  return { trackPlausibleEvent };
};
